import { Controller } from "stimulus"
import Highcharts from "highcharts"

export default class extends Controller
  connect: ->
    regions_map = { us: 'North America', eu: 'Europe', sa: 'South America', as: 'Asia', au: 'Australia' }
    colors_map = { us: '#9c6ade', eu: '#47c1bf', sa: '#DE3618', as: '#eec200', au: '#50B83C' }

    hidden_regions = [] # maybe todo

    series = JSON.parse(@element.dataset.chart).map (regionData) ->
      Object.assign(regionData, color: colors_map[regionData.name], visible: hidden_regions.indexOf(regionData.name) == -1)

    chart = Highcharts.chart @element,
      chart:
        type: 'spline'
        spacingLeft: 10
        spacingTop: 10
        height: 320
        events:
          render: ->
            return unless window.parent?
            window.parent.postMessage {
              sentinel: 'amp'
              type: 'embed-size'
              height: @chartHeight
            }, '*'
      title:
        text: ""
      legend:
        align: "center" 
        margin: 20
        itemDistance: 30
        itemMarginTop: 10
        itemMarginBottom: 10
        itemStyle:
          paddingLeft: "100px"
        labelFormatter: ->
          regions_map[@name]

      xAxis:
        type: 'datetime'
        marker: enabled: false
        labels: formatter: ->
          Highcharts.dateFormat('%I:%M%P', @value)
      yAxis:
        title: text: 'milliseconds'
        minorTicks: true
      plotOptions:
        line: marker: false
        series:
          turboThreshold: 0
          marker: false
          animation: false
          lineWidth: 1
          states: hover: lineWidth: 1
      series: series
      tooltip: formatter: ->
        point = @
        timestamp = "<span style=\"font-size: 10px\">#{(new Date(point.point.dt)).toString()}</span>"
        color_point = "<div style='width: 8px; height: 8px; background: #{point.color}; border-radius: 8px; display: inline-block; margin-right: 4px;'></div>"
        region = regions_map[point.series.name]

        value = "#{Math.round(@.y)} ms"

        "#{timestamp}<br/>#{color_point}<b>#{region}: #{value}</b>"
